export enum SnackbarType {
  error = 'error',
  warning = 'warning',
  success = 'success',
  info = 'info',
}
